export default __webpack_public_path__ + "static/media/view1_year_province.aa6b19fb.csv";